import React, { useEffect } from 'react'
import SchoolQuestionView from './components/SchoolQuestionView'
import { withTranslation } from 'react-i18next'
import { addToGoogleDataLayer } from 'shared/const/utls.js'

const SchoolQuestion = ({ i18n }) => {
  useEffect(() => {
    try {
      addToGoogleDataLayer('school-question', 'Pay for a Road Test', i18n.language)
      window.scrollTo(0, 0)
    } catch (e) {
      console.log(e)
    }
  }, [])

  return <SchoolQuestionView />
}

export default withTranslation('common')(SchoolQuestion)
